import { addStoreImageUrlGroup } from "../content/model";
import { setStoreImgPreview } from "../message/model";

// Данный action делает удаление всех данных из стора. Событие: клик на кнопку закрыть ImgPreview
export var deleteMessagePreview = function deleteMessagePreview() {
  return function (dispatch) {
    dispatch(setStoreImgPreview({
      isImgPreviewOpen: false,
      type: null
    }));
    dispatch(addStoreImageUrlGroup(null));
  };
};